<h1>Area Items</h1>
<div class="components-container">
  <!-- Single Item - Full Width -->
  <div>
    <h3>Single Item - Full Width</h3>
    <div class="clickable-area-options-row">
      <div class="clickable-area-options-row-item">
        <div class="icon">
          <mzic-svg src="assets/icons/mzic-playlist-2.svg" class="purple-500" />
        </div>
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">
            Selecionar composição
          </div>
          <div class="description neutral-300 text-body-xsm">
            Utilize as informações de uma composição salva no seu catálogo
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Two Items Row -->
  <div>
    <h3>Two Items Row</h3>
    <div class="clickable-area-options-row">
      <div class="clickable-area-options-row-item">
        <div class="icon">
          <mzic-svg src="assets/icons/mzic-plus.svg" class="purple-500" />
        </div>
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">
            Nova composição
          </div>
          <div class="description neutral-300 text-body-xsm">
            Crie uma nova composição do zero
          </div>
        </div>
      </div>
      <div class="clickable-area-options-row-item">
        <div class="icon">
          <mzic-svg src="assets/icons/mzic-search.svg" class="purple-500" />
        </div>
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">
            Buscar no catálogo
          </div>
          <div class="description neutral-300 text-body-xsm">
            Encontre uma composição existente
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Three Items Row -->
  <div>
    <h3>Three Items Row</h3>
    <div class="clickable-area-options-row">
      <div class="clickable-area-options-row-item">
        <div class="icon">
          <mzic-svg src="assets/icons/mzic-upload.svg" class="purple-500" />
        </div>
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">Upload</div>
          <div class="description neutral-300 text-body-xsm">
            Faça upload de arquivo
          </div>
        </div>
      </div>
      <div class="clickable-area-options-row-item">
        <div class="icon">
          <mzic-svg src="assets/icons/mzic-link.svg" class="purple-500" />
        </div>
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">Link externo</div>
          <div class="description neutral-300 text-body-xsm">
            Adicione um link
          </div>
        </div>
      </div>
      <div class="clickable-area-options-row-item">
        <div class="icon">
          <mzic-svg src="assets/icons/mzic-edit.svg" class="purple-500" />
        </div>
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">Editar</div>
          <div class="description neutral-300 text-body-xsm">
            Modifique os detalhes
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Item Selected State -->
  <div>
    <h3>Selected State</h3>
    <div class="clickable-area-options-row">
      <div class="clickable-area-options-row-item marked">
        <div class="icon">
          <mzic-svg src="assets/icons/mzic-playlist-2.svg" class="purple-500" />
        </div>
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">
            Item selecionado
          </div>
          <div class="description neutral-300 text-body-xsm">
            Este item está atualmente selecionado
          </div>
        </div>
      </div>
      <div class="clickable-area-options-row-item">
        <div class="icon">
          <mzic-svg src="assets/icons/mzic-plus.svg" class="purple-500" />
        </div>
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">Item normal</div>
          <div class="description neutral-300 text-body-xsm">
            Este item não está selecionado
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Disabled State -->
  <div>
    <h3>Disabled State</h3>
    <div class="clickable-area-options-row">
      <div class="clickable-area-options-row-item disabled">
        <div class="icon">
          <mzic-svg src="assets/icons/mzic-lock.svg" class="purple-500" />
        </div>
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">
            Item desabilitado
          </div>
          <div class="description neutral-300 text-body-xsm">
            Este item não pode ser selecionado
          </div>
        </div>
      </div>
      <div class="clickable-area-options-row-item">
        <div class="icon">
          <mzic-svg src="assets/icons/mzic-unlock.svg" class="purple-500" />
        </div>
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">
            Item habilitado
          </div>
          <div class="description neutral-300 text-body-xsm">
            Este item pode ser selecionado
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Without Icon -->
  <div>
    <h3>Without Icon</h3>
    <div class="clickable-area-options-row">
      <div class="clickable-area-options-row-item">
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">
            Título sem ícone
          </div>
          <div class="description neutral-300 text-body-xsm">
            Esta opção não possui um ícone associado
          </div>
        </div>
      </div>
      <div class="clickable-area-options-row-item">
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">Outra opção</div>
          <div class="description neutral-300 text-body-xsm">
            Descrição da opção sem ícone
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Only Title -->
  <div>
    <h3>Only Title (No Description)</h3>
    <div class="clickable-area-options-row">
      <div class="clickable-area-options-row-item">
        <div class="icon">
          <mzic-svg src="assets/icons/mzic-music-note.svg" class="purple-500" />
        </div>
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">
            Apenas título
          </div>
        </div>
      </div>
      <div class="clickable-area-options-row-item">
        <div class="icon">
          <mzic-svg src="assets/icons/mzic-star.svg" class="purple-500" />
        </div>
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">Outro título</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty Item (Placeholder) -->
  <div>
    <h3>With Empty Placeholder</h3>
    <div class="clickable-area-options-row">
      <div class="clickable-area-options-row-item">
        <div class="icon">
          <mzic-svg src="assets/icons/mzic-plus.svg" class="purple-500" />
        </div>
        <div class="text-container">
          <div class="title purple-500 text-body-md-semibold">
            Adicionar item
          </div>
          <div class="description neutral-300 text-body-xsm">
            Clique para adicionar um novo item
          </div>
        </div>
      </div>
      <div class="clickable-area-options-row-item empty"></div>
    </div>
  </div>
</div>
